/*----------------------------
    Menu Toggle
-----------------------------*/
$(".js-menu-toggle").on("click", function (e) {
    e.preventDefault();
    $(".js-menu").toggleClass("nav--active");
    $("body").toggleClass("is-active");
    $("html").toggleClass("is-active");
    $(this).toggleClass("is-active");

    menuAnimation();
});

/*------------------------------
    Showing / Hiding Sub Menu
-------------------------------*/
$(".js-services-menu a").on("click", function (e) {
    e.preventDefault();
    $(".js-menu-list").hide();
    $(".js-services-submenu").fadeIn();
});

$(".js-courses-menu a").on("click", function (e) {
    e.preventDefault();
    $(".js-menu-list").hide();
    $(".js-courses-submenu").fadeIn();
});

$(".js-back-main-menu").on("click", function (e) {
    e.preventDefault();
    $(".js-services-submenu").hide();
    $(".js-courses-submenu").hide();
    $(".js-menu-list").fadeIn();
    $(".menu-item").addClass("menu-item--no-animate");
});

/*----------------------------
    Menu Item Hovers
-----------------------------*/
$(".menu-item a").hover(
    function () {
        $(".menu-item a").not(this).addClass("fade");
    },
    function () {
        $(".menu-item a").removeClass("fade");
    }
);

$(".js-services-menu-item").hover(
    function () {
        $(".js-services-menu-item")
            .not(this)
            .addClass("services-sub-menu__item--fade");
    },
    function () {
        $(".js-services-menu-item").removeClass(
            "services-sub-menu__item--fade"
        );
    }
);

$(".js-courses-menu-item").hover(
    function () {
        $(".js-courses-menu-item")
            .not(this)
            .addClass("courses-sub-menu__item--fade");
    },
    function () {
        $(".js-courses-menu-item").removeClass("courses-sub-menu__item--fade");
    }
);

/*----------------------------------------------
    Hiding/Showing of Menu on Scroll on Mobile
------------------------------------------------*/
var distance = 50,
    lastScrollTop = 0,
    header = $(".js-header");

$(window).on("scroll", function () {
    var menuClosed = $(".nav--active").length == 0;
    if (menuClosed) {
        var st = $(this).scrollTop();
        if (st > distance) {
            header.addClass("header--hide");
        } else {
            header.removeClass("header--hide");
        }

        if (st < lastScrollTop) {
            header.removeClass("header--hide");
        } else {
            if (st > distance) {
                header.addClass("header--hide");
            }
        }
        lastScrollTop = st;
    }
});

$(window).on("resize", function () {
    header.removeClass("hide");
});

function menuAnimation() {
    if ($(".js-menu").hasClass("nav--active")) {
        $(".menu-item").addClass("menu-item--active");
        $(".js-menu-footer").addClass("nav__footer--active");
        $(".js-nav-btn-mobile").addClass("nav__btn-mobile--active");
    } else {
        $(".menu-item").removeClass("menu-item--active");
        $(".js-menu-footer").removeClass("nav__footer--active");
        $(".js-nav-btn-mobile").removeClass("nav__btn-mobile--active");
        $(".menu-item").removeClass("menu-item--no-animate");
    }
}



// WEBPACK FOOTER //
// ./scripts/partials/menu.js